<template>
  <div class="new-home-page" id="home">
    <HeroBanner />
    <CompanyIntro />
    <ServiceSection />
    <EnterpriseStrength />
    <CooperationBrands />
    <QysmSection />
    <SiteFooter />

    <div class="fixed-tools">
      <button class="tool-btn" type="button" @click="scrollToTop">↑</button>
      <button class="tool-btn" type="button" @click="callPhone">☎</button>
    </div>

    <button class="ai-fab" type="button" @click="openAi">Ai</button>
  </div>
</template>

<script>
import HeroBanner from '@/components/layout/newHome/sections/HeroBanner.vue'
import CompanyIntro from '@/components/layout/newHome/sections/CompanyIntro.vue'
import ServiceSection from '@/components/layout/newHome/sections/ServiceSection.vue'
import EnterpriseStrength from '@/components/layout/newHome/sections/EnterpriseStrength.vue'
import CooperationBrands from '@/components/layout/newHome/sections/CooperationBrands.vue'
import QysmSection from '@/components/layout/newHome/sections/QysmSection.vue'
import SiteFooter from '@/components/layout/newHome/sections/SiteFooter.vue'

export default {
  name: 'NewHome',
  components: {
    HeroBanner,
    CompanyIntro,
    ServiceSection,
    EnterpriseStrength,
    CooperationBrands,
    QysmSection,
    SiteFooter
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goHome() {
      this.$router.push('/')
    },
    callPhone() {
      window.location.href = 'tel:4008818590'
    },
    openAi() {
      window.open('https://ai.din-cn.com/174581243398348/apps/174589461395083/m-chat', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.new-home-page {
  background: #f4f4f4;
  min-width: 1200px;
}

.fixed-tools {
  position: fixed;
  right: 20px;
  top: 46%;
  transform: translateY(-50%);
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tool-btn {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 1px solid #dbe4f3;
  background: #fff;
  color: #1c51a3;
  font-size: 22px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.ai-fab {
  position: fixed;
  right: 20px;
  bottom: 24px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 2px solid #7e52ff;
  color: #7e52ff;
  background: #fff;
  font-size: 22px;
  font-weight: 600;
  cursor: pointer;
  z-index: 20;
}
</style>
